// extracted by mini-css-extract-plugin
module.exports = {"Slide":"SomeOfOurAchievements_Slide__Vy_h5","Slider":"SomeOfOurAchievements_Slider__qcBpS","SlideTrack":"SomeOfOurAchievements_SlideTrack__xD9TH"};